import React from "react";
import { ChunkCitation, OrgCategory } from "../../generated/core-api";
import { useChunkExpansion } from "../hooks/useChunkExpansion";
import styles from "./CitationView.module.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface CitationChunkItemProps {
  citation: ChunkCitation;
}

export const CitationChunkItem: React.FC<CitationChunkItemProps> = ({
  citation,
}) => {
  const { expanded, chunkData, isLoading, error, handleExpand } =
    useChunkExpansion(
      citation.org_category as OrgCategory,
      citation.org_id,
      citation.doc_id,
      citation.chunk_id
    );

  return (
    <li className={styles.citationChunkItem}>
      <div className={styles.chunkHeader}>
        <span>
          ID: {citation.chunk_id}, Index: {citation.chunk_index}
        </span>
        <button
          className={styles.expandButton}
          onClick={handleExpand}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : expanded ? "- Collapse" : "+ Expand"}
        </button>
      </div>

      {expanded && (
        <div className={styles.chunkContent}>
          {error ? (
            <div className={styles.error}>{error}</div>
          ) : chunkData ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {chunkData.chunk_text}
            </ReactMarkdown>
          ) : null}
        </div>
      )}
    </li>
  );
};
